var ImageIcon = function(props) {
	var className = "imageIcon";
	if (props.className) {
		className = className + " " + props.className;
	}

	var src = dynamicRequire("official-icons/" + props.icon + ".png");

	var width = props.width || "auto";
	var height = props.height || "auto";

	var imgProps = _.omit(props, "width", "height", "icon", "type", "className")

	return (
		<img { ...imgProps } width={ width } height={ height }
			src={ src } className={ className } />
	);
}

ImageIcon.propTypes = StrictPropTypes({
	// "imageIcon" class will be added to this
	className: PropTypes.string,

	// Glyphion suffix
	icon: PropTypes.string.isRequired,

	// Dimension
	width: PropTypes.number,
	height: PropTypes.number,

	// Origin
	type: PropTypes.string,

	//Styling
	style: PropTypes.object
});

module.exports = ImageIcon;


// WEBPACK FOOTER //
// ./modules/components/utility/icons/ImageIcon.js